import React, {useState} from "react";
import Swal from "sweetalert2";
import { useHistory } from 'react-router-dom';
import { useForm } from "react-hook-form";

// Material-UI
import {
  Button,
  Container,
  Paper,
  makeStyles,
  TextField,
  Grid,
  InputAdornment,
  IconButton,
} from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
// Components
import NavbarUser from "../components/NavbarUser";
import Background from "../components/BackgroundPattern";
import TitlePage from "../components/TitlePageUser";
import Footer from "../components/Footer";

const useStyle = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh"
  },
  paper: {
    padding: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(2, 0),
  },
}));

const InputPassword = ({ classes }) => {
  const { register, handleSubmit } = useForm();
  const history = useHistory();
  const onSubmit = (data) => {
    console.log(data)
    if (data.passwordLama === data.passwordBaru) {
      return Swal.fire({
        icon: "error",
        title: "Gagal Ubah Password!",
        text: "Password Baru sama dengan Password Lama!",
      });
    } else if (data.passwordBaru !== data.passwordBaru2) {
      return Swal.fire({
        icon: "error",
        title: "Password Baru Tidak Sama",
        text: "Silahkan Ketik Ulang Password Baru",
      });
    } else {
      return (
        Swal.fire({
          icon: "success",
          title: "Password Berhasil Diubah",
          text: "Harap ingat password anda!",
        }),
        history.push('/user/beranda')
      );
    }
  };

  // Show Password Lama
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);

  // Show Password Baru
  const [showPasswordBaru, setShowPasswordBaru] = useState(false);
  const handleClickShowPasswordBaru = () => setShowPasswordBaru(!showPasswordBaru);
  const handleMouseDownPasswordBaru = () => setShowPasswordBaru(!showPasswordBaru);

  //Show Konfirmasi Password Baru
  const [showPasswordBaruDua, setShowPasswordBaruDua] = useState(false);
  const handleClickShowPasswordBaruDua = () => setShowPasswordBaruDua(!showPasswordBaruDua);
  const handleMouseDownPasswordBaruDua = () => setShowPasswordBaruDua(!showPasswordBaruDua);

  return (
    <Container>
      <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
        <Grid container>
          <Grid item xs={12} sm={6}>
            <Paper elevation={3} className={classes.paper}>
              <TextField
                id="passwordLama"
                name="passwordLama"
                label="Password Lama"
                inputRef={register({ required: true })}
                type={showPassword ? "text" : "password"}
                variant="outlined"
                margin="normal"
                required
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
              <TextField
                id="passwordBaru"
                name="passwordBaru"
                label="Password Baru"
                inputRef={register({ required: true })}
                type={showPasswordBaru ? "text" : "password"}
                variant="outlined"
                margin="normal"
                required
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPasswordBaru}
                        onMouseDown={handleMouseDownPasswordBaru}
                      >
                        {showPasswordBaru ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
              <TextField
                id="passwordBaru2"
                name="passwordBaru2"
                label="Konfirmasi Password Baru"
                inputRef={register({ required: true })}
                type={showPasswordBaruDua ? "text" : "password"}
                variant="outlined"
                margin="normal"
                required
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPasswordBaruDua}
                        onMouseDown={handleMouseDownPasswordBaruDua}
                      >
                        {showPasswordBaruDua ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size="large"
                className={classes.submit}
                fullWidth
              >
                {"Ubah Password"}
              </Button>
            </Paper>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
};

const UserPassword = () => {
  const classes = useStyle();
  return (
    <section id="user-password" className={classes.container}>
      <Background/>
      <NavbarUser />
      <Container style={{flex: "1"}}>
        <TitlePage text="Ubah Password" />
        <InputPassword classes={classes} />
      </Container>
      <Footer />
    </section>
  );
};

export default UserPassword;
